'use client';
import { EmailFile, Headphone, MapsLocation, MersisNoIcon } from '@/src/features/ui/icons/icons';
import { DeviceContext } from '@/src/store/contexts/device-context';
import { useContext } from 'react';
import { GoogleMapComp } from './google-map';

type Props = {};

const ContactInfo = (props: Props) => {
  const { isMobile } = useContext(DeviceContext);
  const v = isMobile ? 28 : 32;
  const googleMapSize = isMobile ? { width: 343, height: 172 } : { width: 540, height: 329 };

  return (
    <div className="flex flex-col justify-around gap-6" data-testid="contactInfo">
      <h2 className="text-xl md:text-2xl">İletişim</h2>
      <div data-testid="map">
        <GoogleMapComp mapSizeW={googleMapSize.width.toString()} mapSizeH={googleMapSize.height.toString()} />
      </div>

      <div className="flex gap-5">
        <MapsLocation width={v} height={v} />
        <div>
          <p className="mb-2 text-base font-bold md:mb-3 md:text-lg">Adres</p>
          <p className="text-sm md:text-base" data-testid="address">
            Anel İş Merkezi Yamanevler Mah. Site Yolu Cad. No:5/6 34768 Ümraniye/ İstanbul
          </p>
        </div>
      </div>
      <div className="flex gap-5">
        <Headphone width={v} height={v} />
        <div>
          <p className="mb-2 text-base font-bold md:mb-3 md:text-lg">Telefon</p>
          <p className="text-sm md:text-base" data-testid="phone">
            0850 644 26 44
          </p>
        </div>
      </div>
      <div className="flex gap-5">
        <EmailFile width={v} height={v} />
        <div>
          <p className="mb-2 text-base font-bold md:mb-3 md:text-lg">E-Posta</p>
          <p className="text-sm md:text-base" data-testid="email">
            destek@hangikredi.com
          </p>
        </div>
      </div>
      <div className="flex gap-5">
        <MersisNoIcon width={v} height={v} />
        <div>
          <p className="mb-2 text-base font-bold md:mb-3 md:text-lg">Mersis No</p>
          <p className="text-sm md:text-base" data-testid="mersis">
            0524052734800011
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
